import * as MR from '@/libs/maybe-ramda'
import * as R from 'ramda'

const buildPurchaserInfo = (data) => {
  const gtRequest = gtDate(data.request_date)
  const subscriptions = MR.of(data.subscriber.subscriptions)

  const activeSubscriptions = subscriptions
    .map(R.filter((v) => gtRequest(v.expires_date)))
    .map(R.keys)
    .getOrElse([])

  const allPurchasedProductIdentifiers = subscriptions
    .map(R.keys)
    .getOrElse([])

  const latestExpirationDate = subscriptions
    .map(R.toPairs)
    .map(getLatestDate)
    .getOrElse(null)

  const allExpirationDates = subscriptions
    .map(R.map(R.map(R.prop('expires_date'))))
    .getOrElse({})

  return {
    entitlements: buildEntitlementInfos(
      data.subscriber.entitlements,
      data.request_date
    ),
    activeSubscriptions,
    allPurchasedProductIdentifiers,
    latestExpirationDate,
    allExpirationDates,
    _response: data
  }
}

const buildEntitlementInfo = (entitlement, identifier, requestDate) => {
  const gtRequest = gtDate(requestDate)

  return {
    identifier,
    isActive:
      entitlement.expires_date === null || gtRequest(entitlement.expires_date)
  }
}

const buildEntitlementInfos = (entitlements, requestDate) =>
  R.pipe(
    R.mapObjIndexed((ent, id) => buildEntitlementInfo(ent, id, requestDate)),
    (infos) => ({
      active: R.filter(R.prop('isActive'))(infos),
      all: infos
    })
  )(entitlements)

const createOfferings = (jsonOfferings) => {
  const offerings = R.pipe(
    R.prop('offerings'),
    R.map(createOffering),
    R.groupBy(R.prop('identifier')),
    R.map(R.head)
  )(jsonOfferings)

  return {
    all: offerings,
    current: offerings[jsonOfferings.current_offering_id]
  }
}

const createOffering = (jsonOffering) => {
  return {
    identifier: jsonOffering.identifier,
    serverDescription: jsonOffering.description,
    availablePackages: jsonOffering.packages.map(createPackage)
  }
}

const createPackage = (jsonPackage) => {
  return {
    identifier: jsonPackage.identifier,
    packageType: toPackageType(jsonPackage.identifier),
    product: {
      identifier: jsonPackage.platform_product_identifier
    }
  }
}

const toPackageType = (identifier) => {
  const typesMap = {
    LIFETIME: /\$rc_lifetime/,
    SIX_MONTH: /\$rc_six_month/,
    THREE_MONTH: /\$rc_three_month/,
    TWO_MONTH: /\$rc_two_month/,
    ANNUAL: /\$rc_annual/,
    MONTHLY: /\$rc_monthly/,
    WEEKLY: /\$rc_weekly/
  }

  return R.pipe(
    R.toPairs,
    R.find(([_, regex]) => R.test(regex, identifier)),
    R.head
  )(typesMap)
}

const gtDate = (date1) => (date2) => new Date(date2) > new Date(date1)

const getLatestDate = R.reduce((iso, p) => {
  return new Date(iso) > new Date(p[1].expires_date) ? iso : p[1].expires_date
}, null)

export {
  buildEntitlementInfo,
  buildEntitlementInfos,
  buildPurchaserInfo,
  createOfferings
}
